import {pillWrapper} from '../pill-wrapper';

import Svg from './trial.svg';

interface Props {
    height?: number;
    width?: number;
}

function SvgComponent(props: Props) {
    return <Svg height={props.height} width={props.width} />;
}

export const TrialPill = pillWrapper(SvgComponent);
